import { Input, PasswordInput, Select, TextArea } from '@srichaitra/ui';

/**
 * A labelled control with its error and hint — the unit every form is built
 * from.
 *
 * It takes the object `useForm().fieldProps(name)` returns and hands it to a
 * Material UI text field, which already assembles the label, the input and the
 * helper text and ties them together with the right ids. So this component is
 * mostly a *rename*: the form hook's vocabulary (`error`, `invalid`) onto the
 * field's. The value is that no screen wires up a label or an
 * aria-describedby by hand, so no screen can get it wrong.
 *
 * `control` names which primitive to render. It is a fixed set rather than a
 * component prop, so a caller cannot pass an arbitrary element and side-step
 * the design system.
 */

const CONTROLS = {
  text: Input,
  password: PasswordInput,
  textarea: TextArea,
  select: Select
};

export function FormField({ label, control = 'text', field, hint, required = false, ...rest }) {
  const Control = CONTROLS[control] ?? Input;

  // `errorId` and `describedBy` are dropped: MUI generates and wires its own
  // helper-text id, and passing a second one would point the control at an
  // element that does not exist.
  const { error, errorId, describedBy, ...controlProps } = field;

  return <Control {...controlProps} label={label} error={error} hint={hint} invalid={Boolean(error)} required={required} {...rest} />;
}
